export function getDetailCustomCsvCustomer()
{
    return({
        type:"GET_DETAIL_CUSTOM_CSV_CUSTOMER"
    })
}